import React, { useContext, useState, useEffect } from 'react';
import '../../css/Products/ProductCard.css';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { AuthContext } from '../../Context/AuthProvider';
import { CartContext } from '../../Context/CartProvider';
import slugify from 'slugify';

const ProductCard = ({ product, type }) => {
  const { user } = useContext(AuthContext);
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();

  const [showAuthPopup, setShowAuthPopup] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [quantity] = useState(1);

  // Set default color if available
  useEffect(() => {
    if (product.colors && product.colors.length > 0) {
      setSelectedColor(product.colors[0].name || product.colors[0]);
    }
  }, [product]);

  // Navigate to product page
  const handleNavigation = (category, subcategory, name, id) => {
    const categorySlug = slugify(category || '', {
      lower: true,
      strict: true,
    });

    const subcategorySlug = slugify(subcategory || '', {
      lower: true,
      strict: true,
    });

    const productSlug = slugify(name || '', {
      lower: true,
      strict: true,
    });

    navigate(
      `/termek/${categorySlug}/${subcategorySlug}/${productSlug}/${id}`,
      {
        state: { type: type },
      }
    );
  };

  // Add product to cart
  const handleCart = (e) => {
    // Prevent card click from navigating to product page
    e.stopPropagation();

    if (!user) {
      setShowAuthPopup(true);
      return;
    }

    const cartItem = {
      id: Number(product.id),
      item: product.product_name,
      image: product.image,
      color: selectedColor ?? null,
      price: Number(product.price),
    };

    addToCart(cartItem, Number(quantity));
  };

  // Product images
  const imageArray = product.image?.split(',') || [];

  return (
    <div
      className="product-card"
      onClick={() =>
        handleNavigation(
          product.category,
          product.subcategory,
          product.product_name,
          product.id
        )
      }
    >
      {/* Product image */}
      <div className="product-card-image">
        <Carousel
          showThumbs={false}
          infiniteLoop
          showStatus={false}
          useKeyboardArrows
          autoPlay={false}
          showIndicators={false}
        >
          {imageArray.map((img, index) => (
            <div key={index}>
              <img
                src={`/uploads/${img.trim()}`}
                alt={`Product image ${index + 1}`}
              />
            </div>
          ))}
        </Carousel>
      </div>

      {/* Product information */}
      <div className="product-card-info">
        <h3 className="product-card-name">
          {product.product_name}
        </h3>

        {/* Stock */}
        <p className="product-card-stock">
          {product.stock === 1 && 'Raktáron'}
          {product.stock === 2 && 'Rendelhető'}
        </p>

        {/* Whole price / discount price */}
        {!user && product.discount_percentage > 0 && (
          <p className="wholeprice">
            {Number(product.wholePrice).toLocaleString('hu-HU', {
              style: 'currency',
              currency: 'HUF',
            })}
          </p>
        )}

        {/* Product price */}
        <h3 className="product-card-price">
          {product.price
            ? Number(product.price).toLocaleString('hu-HU', {
                style: 'currency',
                currency: 'HUF',
              })
            : null}
        </h3>

        {/* Color selector */}
        {product.colors?.length > 0 && (
          <select
            value={selectedColor || ''}
            onChange={(e) => setSelectedColor(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          >
            {product.colors.map((color, idx) => (
              <option key={idx} value={color.name || color}>
                {color.name || color}
              </option>
            ))}
          </select>
        )}

        {/* Action button */}
        {product.price ? (
          <button onClick={handleCart}>
            Kosárba
          </button>
        ) : (null)}
      </div>

      {/* Authentication popup */}
      {showAuthPopup && (
        <div
          className="auth-popup-overlay"
          onClick={() => setShowAuthPopup(false)}
        >
          <div
            className="auth-popup-card"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Bejelentkezés szükséges</h3>

            <p>
              A kosár használatához kérjük jelentkezz be vagy regisztrálj.
            </p>

            <div className="auth-popup-actions">
              <button onClick={() => navigate('/fiok')}>
                Bejelentkezés
              </button>

              <button onClick={() => navigate('/fiok')}>
                Regisztráció
              </button>
            </div>

            <button
              className="auth-popup-close"
              onClick={() => setShowAuthPopup(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
